import { deserialize } from 'cerialize'
import { WeekScheduleModel } from 'Pages/company'

export class CompanyModel {
	@deserialize public id: number
	@deserialize public partner_id: number
	@deserialize public partner_name?: number
	@deserialize public vat_number?: number
	@deserialize public phone: string
	@deserialize public primary: boolean
	@deserialize public created_at?: string
	@deserialize public week_schedule: WeekScheduleModel
	@deserialize public data: any
	@deserialize public show_on_map: boolean
	@deserialize public updated_at?: string
}
